import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { getOtpForForgotPassword } from "../services/Un_auth_services";
import ResetPasswordModal from "../resetPasswordSuccess/resetPassword";
import { Input, Button } from "antd";
import { useSelector } from "react-redux";

const ForgotPassword3 = () => {
  const routes = all_routes;
  const language = useSelector((state: any) => state.auth.language);
  const [email, setEmail] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const [refId, setRefId] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();

  const role = searchParams.get("role");

  const allowedRoles = [
    "Trader_Registration",
    "Panel_Engineer_Registration",
    "Trader_Login",
    "Panel_Engineer_Login",
    "District_Registrar_Login",
    "APMC_Login",
    "Head_officer_Login",
    "GCA_Login",
     "GCA_Registration",
      "Sponsor_Login",
     "Sponsor_Registration"
  ];
  //.log("role...........", role);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;

      const savedTime = localStorage.getItem("exp");
        const now = Date.now();

         if (savedTime && Number(savedTime) > now) {
    // setRefId(savedRefId);
    setIsModalOpen(true);
    return;
  }

    setIsSubmitting(true);

    let values;

    if (role === "Trader_Login" || role === "Panel_Engineer_Login"||role === "GCA_Login" || role === "Sponsor_Login") {
      values = { email: email, mobileNo: "", role };
    } else {
      values = {
        email: email,
        username: username,
        mobile: "",
        key: "Dist",
        role,
      };
    }

    try {
      const response = await getOtpForForgotPassword(values);
      if (response.Status) {
        alert(response.Message)
        const expiry = Date.now() + 10 * 60 * 1000;
        localStorage.setItem("exp", expiry.toString());
        setRefId(response.RefId);
        setIsModalOpen(true);
      } else {
        alert(response.message);
      }
    } catch (error) {
      
      // //.error("Error fetching OTP:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (!role||!allowedRoles.includes(role ?? "")) {
      navigation(routes.error404); 
    }
  }, [role]);




  return (
    <>
      <div className="container-fluid">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
            <div className="col-md-4 mx-auto vh-100">
              <form onSubmit={handleSubmit} className="vh-100">
                <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                  <div className="mx-auto mb-5 text-center">
                    {/* Logo here */}
                  </div>
                  <div className="">
                    <div className="text-center mb-3">
                      <h2 className="mb-2">{language.forgot_password}?</h2>
                      <p className="mb-0">
                        {language.forgot_head}
                      </p>
                    </div>

                    {/* Email Input */}
                    {(role === "Trader_Login" ||
                      role === "Panel_Engineer_Login"||role === "GCA_Login" || role === "Sponsor_Login") && (
                      <div className="mb-3">
                        <label className="form-label">{language.email}</label>
                        <div className="input-group">
                          <input
                            type="email"
                            value={email}
                            maxLength={70}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control border-end-0"
                            required
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Username Input (Only for non-Trader & non-Panel Engineer roles) */}
                    {role !== "Trader_Login" &&
                      role !== "Panel_Engineer_Login"&&role !== "GCA_Login" && role !== "Sponsor_Login" && (
                        <div className="mb-3">
                          <label className="form-label">{language.username}</label>
                          <div className="input-group">
                            <input
                              type="text"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              className="form-control border-end-0"
                              required
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-user" />
                            </span>
                          </div>
                        </div>
                      )}

                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-success w-100"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending OTP..." : "Submit"}
                      </button>
                    </div>
                    <div className="text-center">
                      <h6 className="fw-normal text-dark mb-0">
                        {language.return_to}&nbsp;
                        <Link
                          to={routes.Home}
                          className="text-success hover:underline"
                        >
                         {language.home}
                        </Link>
                      </h6>
                    </div>
                  </div>
                  <div className="mt-5 pb-4 text-center"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ResetPasswordModal
        email={email}
        refId={refId}
        username={username}
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ForgotPassword3;
